<app-tab-toolbar [tabId]="'society'" [selectedYear]="selectedYear" [saveDisabled]="!hasChanges && !isCarriedForward" [showOtherMeasurement]="true" [otherMeasurement]="otherMeasurement" [showKeywordsToggle]="true" [keywordsVisible]="showKeywords" (keywordsVisibleChange)="showKeywords = $event" (yearChange)="onYearChange($event)" (otherMeasurementChange)="onOtherMeasurementChange($event)" (save)="onSave()">
  @if (showYearWarning) {
    <div class="year-warning">
      <mat-icon>{{ isCarriedForward ? 'info' : 'warning' }}</mat-icon>
      @if (isCarriedForward) {
        <span>There is no data for the selected year. Some fields are shown from a previous year.</span>
      } @else {
        <span>There is no data for the selected year</span>
      }
    </div>
  }
</app-tab-toolbar>

<div class="society-content" [formGroup]="form" [appReadOnlyTab]="'society'">

  <div class="columns-wrapper">

    <!-- ── LEFT COLUMN ────────────────────────────────────────────────── -->
    <div class="column">

      <section class="section-container nrg-border-radius-second-level">
        <div class="section-header">
          <span>Assurance and Standards</span>
        </div>
        <div class="section-content">

          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Chief Sustainability Officer</mat-label>
            <input matInput formControlName="chiefSustainabilityOfficer" appTextNormalize>
          </mat-form-field>
          @if (otherMeasurement && otherData?.chiefSustainabilityOfficer) {
            <div class="comparison-hint">{{ otherData!.chiefSustainabilityOfficer }}</div>
          }

          <div class="checkbox-field">
            <mat-checkbox formControlName="isCsrCommittee">ESG Committee</mat-checkbox>
          </div>
          @if (otherMeasurement && otherData) {
            <div class="comparison-hint">{{ otherData.isCsrCommittee ? 'Yes' : 'No' }}</div>
          }

          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Environmental Management System</mat-label>
            <mat-select formControlName="environmentalStandardId">
              <mat-option value="">(None)</mat-option>
              @for (s of environmentalStandards; track s.id) {
                <mat-option [value]="s.id">{{ s.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (otherMeasurement) {
            @let envStd = getOtherStandardName(otherData?.environmentalStandardId);
            @if (envStd) { <div class="comparison-hint">{{ envStd }}</div> }
          }

          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Standard</mat-label>
            <mat-select formControlName="standardId">
              <mat-option value="">(None)</mat-option>
              @for (s of allStandards; track s.id) {
                <mat-option [value]="s.id">{{ s.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (otherMeasurement) {
            @let std = getOtherStandardName(otherData?.standardId);
            @if (std) { <div class="comparison-hint">{{ std }}</div> }
          }

          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Assurance Provider</mat-label>
            <mat-select formControlName="assuranceProviderId">
              <mat-option value="">(None)</mat-option>
              @for (p of assuranceProviders; track p.id) {
                <mat-option [value]="p.id">{{ p.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (otherMeasurement) {
            @let ap = getOtherAssuranceProviderName();
            @if (ap) { <div class="comparison-hint">{{ ap }}</div> }
          }

          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Assurance Name</mat-label>
            <input matInput formControlName="assuranceName" appTextNormalize>
          </mat-form-field>
          @if (otherMeasurement && otherData?.assuranceName) {
            <div class="comparison-hint">{{ otherData!.assuranceName }}</div>
          }

          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Assurance Date</mat-label>
            <input matInput [matDatepicker]="assuranceDatePicker" formControlName="assuranceDate">
            <mat-datepicker-toggle matIconSuffix [for]="assuranceDatePicker" />
            <mat-datepicker #assuranceDatePicker />
          </mat-form-field>
          @if (otherMeasurement) {
            @let dateVal = formatDate(otherData?.assuranceDate);
            @if (dateVal) { <div class="comparison-hint">{{ dateVal }}</div> }
          }

          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Reporting Standard 1</mat-label>
            <mat-select formControlName="reportingStandard1Id">
              <mat-option value="">(None)</mat-option>
              @for (s of reportingStandards; track s.id) {
                <mat-option [value]="s.id">{{ s.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (otherMeasurement) {
            @let rs1 = getOtherStandardName(otherData?.reportingStandard1Id);
            @if (rs1) { <div class="comparison-hint">{{ rs1 }}</div> }
          }

          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Reporting Standard 2</mat-label>
            <mat-select formControlName="reportingStandard2Id">
              <mat-option value="">(None)</mat-option>
              @for (s of reportingStandards; track s.id) {
                <mat-option [value]="s.id">{{ s.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (otherMeasurement) {
            @let rs2 = getOtherStandardName(otherData?.reportingStandard2Id);
            @if (rs2) { <div class="comparison-hint">{{ rs2 }}</div> }
          }

          @if (showKeywords) {
            <div class="keywords-section" formGroupName="keywords">
              <div class="section-header">
                <span>Keywords</span>
              </div>
              <div class="keywords-fields">
                <app-keyword-input name="assurance" label="Assurance" />
              </div>
            </div>
          }

        </div>
      </section>

      <section class="section-container nrg-border-radius-second-level">
        <div class="section-header">
          <span>Anti-corruption</span>
        </div>
        <div class="section-content">

          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Anti-corruption Training - Board of Directors</mat-label>
            <input matInput type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="antiCorruptionTrainingBoardOfDirectors">
            <span matSuffix>%</span>
          </mat-form-field>
          @if (otherMeasurement && otherData?.antiCorruptionTrainingBoardOfDirectors != null) {
            <div class="comparison-hint">{{ formatNumber(otherData!.antiCorruptionTrainingBoardOfDirectors!, 2) }}%</div>
          }

          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Anti-corruption Training - Employees</mat-label>
            <input matInput type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="antiCorruptionTrainingEmployees">
            <span matSuffix>%</span>
          </mat-form-field>
          @if (otherMeasurement && otherData?.antiCorruptionTrainingEmployees != null) {
            <div class="comparison-hint">{{ formatNumber(otherData!.antiCorruptionTrainingEmployees!, 2) }}%</div>
          }

          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Anti-corruption Training - Suppliers</mat-label>
            <input matInput type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="antiCorruptionTrainingSuppliers">
            <span matSuffix>%</span>
          </mat-form-field>
          @if (otherMeasurement && otherData?.antiCorruptionTrainingSuppliers != null) {
            <div class="comparison-hint">{{ formatNumber(otherData!.antiCorruptionTrainingSuppliers!, 2) }}%</div>
          }

          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Confirmed Incidents of Corruption</mat-label>
            <input matInput type="text" inputmode="numeric" appNumberFormat formControlName="confirmedIncidentsOfCorruption">
          </mat-form-field>
          @if (otherMeasurement && otherData?.confirmedIncidentsOfCorruption != null) {
            <div class="comparison-hint">{{ formatNumber(otherData!.confirmedIncidentsOfCorruption!) }}</div>
          }

          @if (showKeywords) {
            <div class="keywords-section" formGroupName="keywords">
              <div class="section-header">
                <span>Keywords</span>
              </div>
              <div class="keywords-fields">
                <app-keyword-input name="corruption" label="Corruption" />
              </div>
            </div>
          }

        </div>
      </section>

      <section class="section-container nrg-border-radius-second-level">
        <div class="section-header">
          <span>Human Rights</span>
        </div>
        <div class="section-content">

          <div class="checkbox-field">
            <mat-checkbox formControlName="hasHumanRightsPolicy">Human Rights Policy</mat-checkbox>
          </div>
          @if (otherMeasurement && otherData) {
            <div class="comparison-hint">{{ otherData.hasHumanRightsPolicy ? 'Yes' : 'No' }}</div>
          }

          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Human Rights - Training Hours</mat-label>
            <input matInput type="text" inputmode="numeric" appNumberFormat formControlName="humanRightsTrainingHours">
          </mat-form-field>
          @if (otherMeasurement && otherData?.humanRightsTrainingHours != null) {
            <div class="comparison-hint">{{ formatNumber(otherData!.humanRightsTrainingHours!) }}</div>
          }

          <div class="form-field-container-with-columns">
            <div class="field-with-hint">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Participants</mat-label>
                <input matInput type="text" inputmode="numeric" appNumberFormat formControlName="humanRightsParticipants">
              </mat-form-field>
              @if (otherMeasurement && otherData?.humanRightsParticipants != null) {
                <div class="comparison-hint">{{ formatNumber(otherData!.humanRightsParticipants!) }}</div>
              }
            </div>
            <div class="field-with-hint">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Participants (Persons)</mat-label>
                <input matInput type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="humanRightsParticipantsPersons">
                <span matSuffix>%</span>
              </mat-form-field>
              @if (otherMeasurement && otherData?.humanRightsParticipantsPersons != null) {
                <div class="comparison-hint">{{ formatNumber(otherData!.humanRightsParticipantsPersons!, 2) }}%</div>
              }
            </div>
          </div>

          @if (showKeywords) {
            <div class="keywords-section" formGroupName="keywords">
              <div class="section-header">
                <span>Keywords</span>
              </div>
              <div class="keywords-fields">
                <app-keyword-input name="humanRight" label="Human Rights" />
              </div>
            </div>
          }

        </div>
      </section>

    </div>

    <!-- ── RIGHT COLUMN ───────────────────────────────────────────────── -->
    <div class="column">

      <section class="section-container nrg-border-radius-second-level">
        <div class="section-header">
          <span>Community Engagement</span>
        </div>
        <div class="section-content">

          <div class="amount-currency-row">
            <div class="amount-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Cash Donations</mat-label>
                <input matInput type="text" inputmode="numeric" appNumberFormat formControlName="cashDonations">
              </mat-form-field>
              @if (otherMeasurement && otherData?.cashDonations != null) {
                <div class="comparison-hint">{{ formatNumber(otherData!.cashDonations!) }}</div>
              }
            </div>
            <div class="percentage-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>%</mat-label>
                <input matInput type="text" inputmode="numeric" appNumberFormat [decimals]="2" formControlName="cashDonationsPercentage">
              </mat-form-field>
            </div>
            <div class="currency-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Currency</mat-label>
                <mat-select formControlName="cashDonationsCurrencyId">
                  <mat-option value="">(None)</mat-option>
                  @for (c of currencies; track c.id) {
                    <mat-option [value]="c.id">{{ c.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (otherMeasurement) {
                @let cur = getOtherCurrencyName(otherData?.cashDonationsCurrencyId);
                @if (cur) { <div class="comparison-hint">{{ cur }}</div> }
              }
            </div>
          </div>

          <div class="amount-currency-row">
            <div class="amount-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>In-Kind Donations</mat-label>
                <input matInput type="text" inputmode="numeric" appNumberFormat formControlName="inKindDonations">
              </mat-form-field>
              @if (otherMeasurement && otherData?.inKindDonations != null) {
                <div class="comparison-hint">{{ formatNumber(otherData!.inKindDonations!) }}</div>
              }
            </div>
            <div class="percentage-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>%</mat-label>
                <input matInput type="text" inputmode="numeric" appNumberFormat [decimals]="2" formControlName="inKindDonationsPercentage">
              </mat-form-field>
            </div>
            <div class="currency-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Currency</mat-label>
                <mat-select formControlName="inKindDonationsCurrencyId">
                  <mat-option value="">(None)</mat-option>
                  @for (c of currencies; track c.id) {
                    <mat-option [value]="c.id">{{ c.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (otherMeasurement) {
                @let cur = getOtherCurrencyName(otherData?.inKindDonationsCurrencyId);
                @if (cur) { <div class="comparison-hint">{{ cur }}</div> }
              }
            </div>
          </div>

          <div class="amount-currency-row">
            <div class="amount-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Employee Donations</mat-label>
                <input matInput type="text" inputmode="numeric" appNumberFormat formControlName="employeeDonations">
              </mat-form-field>
              @if (otherMeasurement && otherData?.employeeDonations != null) {
                <div class="comparison-hint">{{ formatNumber(otherData!.employeeDonations!) }}</div>
              }
            </div>
            <div class="percentage-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>%</mat-label>
                <input matInput type="text" inputmode="numeric" appNumberFormat [decimals]="2" formControlName="employeeDonationsPercentage">
              </mat-form-field>
            </div>
            <div class="currency-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Currency</mat-label>
                <mat-select formControlName="employeeDonationsCurrencyId">
                  <mat-option value="">(None)</mat-option>
                  @for (c of currencies; track c.id) {
                    <mat-option [value]="c.id">{{ c.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (otherMeasurement) {
                @let cur = getOtherCurrencyName(otherData?.employeeDonationsCurrencyId);
                @if (cur) { <div class="comparison-hint">{{ cur }}</div> }
              }
            </div>
          </div>

          <div class="amount-currency-row">
            <div class="amount-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Political Contributions</mat-label>
                <input matInput type="text" inputmode="numeric" appNumberFormat formControlName="politicalContributions">
              </mat-form-field>
              @if (otherMeasurement && otherData?.politicalContributions != null) {
                <div class="comparison-hint">{{ formatNumber(otherData!.politicalContributions!) }}</div>
              }
            </div>
            <div class="percentage-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>%</mat-label>
                <input matInput type="text" inputmode="numeric" appNumberFormat [decimals]="2" formControlName="politicalContributionsPercentage">
              </mat-form-field>
            </div>
            <div class="currency-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Currency</mat-label>
                <mat-select formControlName="politicalContributionsCurrencyId">
                  <mat-option value="">(None)</mat-option>
                  @for (c of currencies; track c.id) {
                    <mat-option [value]="c.id">{{ c.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (otherMeasurement) {
                @let cur = getOtherCurrencyName(otherData?.politicalContributionsCurrencyId);
                @if (cur) { <div class="comparison-hint">{{ cur }}</div> }
              }
            </div>
          </div>

          <div class="amount-currency-row">
            <div class="amount-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Community Lending and Investment</mat-label>
                <input matInput type="text" inputmode="numeric" appNumberFormat formControlName="communityLendingInvestment">
              </mat-form-field>
              @if (otherMeasurement && otherData?.communityLendingInvestment != null) {
                <div class="comparison-hint">{{ formatNumber(otherData!.communityLendingInvestment!) }}</div>
              }
            </div>
            <div class="percentage-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>%</mat-label>
                <input matInput type="text" inputmode="numeric" appNumberFormat [decimals]="2" formControlName="communityLendingInvestmentPercentage">
              </mat-form-field>
            </div>
            <div class="currency-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Currency</mat-label>
                <mat-select formControlName="communityLendingInvestmentCurrencyId">
                  <mat-option value="">(None)</mat-option>
                  @for (c of currencies; track c.id) {
                    <mat-option [value]="c.id">{{ c.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (otherMeasurement) {
                @let cur = getOtherCurrencyName(otherData?.communityLendingInvestmentCurrencyId);
                @if (cur) { <div class="comparison-hint">{{ cur }}</div> }
              }
            </div>
          </div>

          <div class="amount-currency-row">
            <div class="amount-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Charities Supported</mat-label>
                <input matInput type="text" inputmode="numeric" appNumberFormat formControlName="charitiesSupported">
              </mat-form-field>
              @if (otherMeasurement && otherData?.charitiesSupported != null) {
                <div class="comparison-hint">{{ formatNumber(otherData!.charitiesSupported!) }}</div>
              }
            </div>
            <div class="percentage-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>%</mat-label>
                <input matInput type="text" inputmode="numeric" appNumberFormat [decimals]="2" formControlName="charitiesSupportedPercentage">
              </mat-form-field>
            </div>
            <div class="currency-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Currency</mat-label>
                <mat-select formControlName="charitiesSupportedCurrencyId">
                  <mat-option value="">(None)</mat-option>
                  @for (c of currencies; track c.id) {
                    <mat-option [value]="c.id">{{ c.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (otherMeasurement) {
                @let cur = getOtherCurrencyName(otherData?.charitiesSupportedCurrencyId);
                @if (cur) { <div class="comparison-hint">{{ cur }}</div> }
              }
            </div>
          </div>

          <div class="amount-currency-row">
            <div class="amount-field">
              <mat-form-field appearance="fill" class="form-field" [class.auto-fill-flash]="donationsTotalAutoFilled">
                <mat-label>Donations Total</mat-label>
                <input matInput type="text" inputmode="numeric" appNumberFormat formControlName="donationsTotal">
              </mat-form-field>
              @if (otherMeasurement && otherData?.donationsTotal != null) {
                <div class="comparison-hint">{{ formatNumber(otherData!.donationsTotal!) }}</div>
              }
            </div>
            <div class="percentage-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>%</mat-label>
                <input matInput value="100,00" readonly>
              </mat-form-field>
            </div>
            <div class="currency-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Currency</mat-label>
                <mat-select formControlName="donationsTotalCurrencyId">
                  <mat-option value="">(None)</mat-option>
                  @for (c of currencies; track c.id) {
                    <mat-option [value]="c.id">{{ c.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (otherMeasurement) {
                @let cur = getOtherCurrencyName(otherData?.donationsTotalCurrencyId);
                @if (cur) { <div class="comparison-hint">{{ cur }}</div> }
              }
            </div>
          </div>

          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Volunteer Hours</mat-label>
            <input matInput type="text" inputmode="numeric" appNumberFormat formControlName="volunteerHours">
          </mat-form-field>
          @if (otherMeasurement && otherData?.volunteerHours != null) {
            <div class="comparison-hint">{{ formatNumber(otherData!.volunteerHours!) }}</div>
          }

          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Volunteer Employees</mat-label>
            <input matInput type="text" inputmode="numeric" appNumberFormat formControlName="volunteerEmployees">
          </mat-form-field>
          @if (otherMeasurement && otherData?.volunteerEmployees != null) {
            <div class="comparison-hint">{{ formatNumber(otherData!.volunteerEmployees!) }}</div>
          }

          @if (showKeywords) {
            <div class="keywords-section" formGroupName="keywords">
              <div class="section-header">
                <span>Keywords</span>
              </div>
              <div class="keywords-fields">
                <app-keyword-input name="donation" label="Donation" />
              </div>
            </div>
          }

        </div>
      </section>

      <section class="section-container nrg-border-radius-second-level">
        <div class="section-header">
          <span>Discrimination and Harassment Incidents</span>
        </div>
        <div class="section-content">

          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Discrimination and Harassment Incidents</mat-label>
            <input matInput type="text" inputmode="numeric" appNumberFormat formControlName="discriminationAndHarassmentIncidents">
          </mat-form-field>
          @if (otherMeasurement && otherData?.discriminationAndHarassmentIncidents != null) {
            <div class="comparison-hint">{{ formatNumber(otherData!.discriminationAndHarassmentIncidents!) }}</div>
          }

          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Losses of Customer Data</mat-label>
            <input matInput type="text" inputmode="numeric" appNumberFormat formControlName="lossesOfCustomerData">
          </mat-form-field>
          @if (otherMeasurement && otherData?.lossesOfCustomerData != null) {
            <div class="comparison-hint">{{ formatNumber(otherData!.lossesOfCustomerData!) }}</div>
          }

          <div class="amount-currency-row">
            <div class="amount-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Monetary Losses</mat-label>
                <input matInput type="text" inputmode="numeric" appNumberFormat formControlName="monetaryLosses">
              </mat-form-field>
              @if (otherMeasurement && otherData?.monetaryLosses != null) {
                <div class="comparison-hint">{{ formatNumber(otherData!.monetaryLosses!) }}</div>
              }
            </div>
            <div class="currency-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Currency</mat-label>
                <mat-select formControlName="monetaryLossesCurrencyId">
                  <mat-option value="">(None)</mat-option>
                  @for (c of currencies; track c.id) {
                    <mat-option [value]="c.id">{{ c.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (otherMeasurement) {
                @let cur = getOtherCurrencyName(otherData?.monetaryLossesCurrencyId);
                @if (cur) { <div class="comparison-hint">{{ cur }}</div> }
              }
            </div>
          </div>

          @if (showKeywords) {
            <div class="keywords-section" formGroupName="keywords">
              <div class="section-header">
                <span>Keywords</span>
              </div>
              <div class="keywords-fields">
                <app-keyword-input name="discrimination" label="Discrimination" />
              </div>
            </div>
          }

        </div>
      </section>

      <section class="section-container nrg-border-radius-second-level">
        <div class="section-header">
          <span>Suppliers</span>
        </div>
        <div class="section-content">

          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Total Number of Suppliers</mat-label>
            <input matInput type="text" inputmode="numeric" appNumberFormat formControlName="totalNumberOfSuppliers">
          </mat-form-field>
          @if (otherMeasurement && otherData?.totalNumberOfSuppliers != null) {
            <div class="comparison-hint">{{ formatNumber(otherData!.totalNumberOfSuppliers!) }}</div>
          }

          <div class="amount-currency-row">
            <div class="amount-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Payment to Suppliers</mat-label>
                <input matInput type="text" inputmode="numeric" appNumberFormat formControlName="paymentToSuppliers">
              </mat-form-field>
              @if (otherMeasurement && otherData?.paymentToSuppliers != null) {
                <div class="comparison-hint">{{ formatNumber(otherData!.paymentToSuppliers!) }}</div>
              }
            </div>
            <div class="currency-field">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Currency</mat-label>
                <mat-select formControlName="paymentToSuppliersCurrencyId">
                  <mat-option value="">(None)</mat-option>
                  @for (c of currencies; track c.id) {
                    <mat-option [value]="c.id">{{ c.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (otherMeasurement) {
                @let cur = getOtherCurrencyName(otherData?.paymentToSuppliersCurrencyId);
                @if (cur) { <div class="comparison-hint">{{ cur }}</div> }
              }
            </div>
          </div>

          @if (showKeywords) {
            <div class="keywords-section" formGroupName="keywords">
              <div class="section-header">
                <span>Keywords</span>
              </div>
              <div class="keywords-fields">
                <app-keyword-input name="suppliers" label="Suppliers" />
              </div>
            </div>
          }

        </div>
      </section>

    </div>

  </div>

  <!-- ── FULL WIDTH: Comments ───────────────────────────────────────────── -->
  <section class="section-container comments-section nrg-border-radius-second-level">
    <div class="section-header">
      <span>Comments</span>
    </div>
    <div class="section-content">
      <mat-form-field appearance="fill" class="form-field">
        <mat-label>Comments</mat-label>
        <textarea matInput formControlName="comments" rows="5"></textarea>
      </mat-form-field>
      @if (otherMeasurement && otherData?.comments) {
        <div class="comparison-hint">{{ otherData!.comments }}</div>
      }
    </div>
  </section>


</div>

<ngx-spinner name="primary" type="ball-spin-clockwise" [fullScreen]="false" size="medium" />
